module.exports = __webpack_public_path__ + "media/kidibul.e07c5166.mp4";